<template>
  <div class="base-radiolist">
    <BaseSearchInput v-if="$props.searchable" v-model="search" class="mb-3" />

    <b-form-group v-bind="$attrs" v-slot="{ ariaDescribedby }">
      <BaseRadiolistSkeleton>
        <b-form-radio-group
          v-if="!!results.length"
          v-model="modelValue"
          :options="results"
          :aria-describedby="ariaDescribedby"
          stacked
        ></b-form-radio-group>

        <p v-else class="mb-0 small">
          <slot name="empty-message">No items found.</slot>
        </p>
      </BaseRadiolistSkeleton>
    </b-form-group>
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  ref,
  provide,
  toRefs
} from '@vue/composition-api'

import { useFuseSearch } from '@composables'
import { BaseSearchInput } from '@components/base'

import BaseRadiolistSkeleton from './BaseRadiolistSkeleton.vue'

export default defineComponent({
  name: 'BaseRadiolist',
  components: {
    BaseSearchInput,

    BaseRadiolistSkeleton
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    value: [String, Number, Boolean],
    searchable: {
      type: Boolean,
      default: true
    },
    searchKeys: {
      type: Array,
      default: () => []
    },
    loading: Boolean
  },
  emits: ['input'],
  setup(props, { emit }) {
    const { options, loading } = toRefs(props)

    const { search, results } = useFuseSearch(options, {
      keys: props.searchKeys
    })

    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    provide('base-radiolist', {
      loading
    })

    return {
      modelValue,

      search,
      results
    }
  }
})
</script>

<style scoped>
.form-group >>> div[role='radiogroup'] {
  max-height: 285px;
  overflow-y: auto;
}

.form-group >>> .custom-control {
  padding-left: 0;
}

.form-group >>> .custom-control-label::before {
  width: 13px;
  height: 13px;
  background-color: #fff;
  border-color: #1c4a50;
  top: 4px;
  left: 0;
}

.form-group >>> .custom-control-label::after {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  top: 7px;
  left: 3px;
  transform: scale(0);
  transform-origin: center;
  transition: all 0.3s ease;
}

.form-group >>> .custom-control-label {
  padding-left: 20px;
  line-height: 1.5;
  display: block;
}

.form-group >>> .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #1c4a50;
  background-image: none;
  transform: scale(1);
}
</style>
